module.exports = __webpack_public_path__ + "img/VL_05_01.47459199.png";